export const ActionTypes = {
	SET_PRODUCTS: 'SET_PRODUCTS',
	SELECTED_PRODUCT: 'SELECTED_PRODUCT',
	REMOVE_SELECTED_PRODUCT: 'REMOVE_SELECTED_PRODUCT',
	ADD_PRODUCT_TO_BASKET: 'ADD_PRODUCT_TO_BASKET',
	CLEAR_BASKET: 'CLEAR_BASKET',
};
